module.exports = __webpack_public_path__ + "static/media/licence2-ever.cc8cab0a.png";